var map = {
	"./BCT168.png": 132,
	"./KPW.png": 173,
	"./LMHSB168.png": 174,
	"./MHSB168.png": 175,
	"./MHSB999.png": 291,
	"./MHSBC.png": 292,
	"./MHSBGREEN.png": 293,
	"./MHSBKP.png": 294,
	"./MT168.png": 295,
	"./ONLINEP99.png": 296,
	"./P99.png": 297,
	"./SBS636.png": 298,
	"./logo-en.png": 178,
	"./logo2.png": 299
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 58;